/**
 * Defers custom.css / custom.js until bottom legacy HTML nears the viewport.
 * Skips if collection-custom-kit-tags already loaded them (top + bottom collections).
 */

const LOADED_STYLES = new Set();
const LOADED_SCRIPTS = new Set();

/**
 * @param {string} url
 */
function ensureStylesheet(url) {
  if (!url || LOADED_STYLES.has(url)) return;
  LOADED_STYLES.add(url);

  if (document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`)) return;
  if (document.querySelector(`link[data-lazy-content-stylesheet][href="${CSS.escape(url)}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  link.media = 'print';
  link.dataset.collectionCustomKitLazy = '';
  link.onload = () => {
    link.media = 'all';
  };
  document.head.appendChild(link);
}

/**
 * @param {string} url
 */
function ensureScript(url) {
  if (!url || LOADED_SCRIPTS.has(url)) return;
  LOADED_SCRIPTS.add(url);

  if (document.querySelector(`script[src="${CSS.escape(url)}"]`)) return;

  const script = document.createElement('script');
  script.src = url;
  script.defer = true;
  script.dataset.collectionCustomKitLazy = '';
  document.head.appendChild(script);
}

/**
 * @param {HTMLElement} host
 */
function loadAssets(host) {
  const css = host.dataset.stylesheet?.trim();
  const js = host.dataset.script?.trim();
  if (css) ensureStylesheet(css);
  if (js) ensureScript(js);
}

class CollectionCustomKitLazy extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      loadAssets(this);
      return;
    }

    const target = this.firstElementChild ?? this;
    const rootMargin = this.dataset.rootMargin || '400px 0px';

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.#observer?.disconnect();
          loadAssets(this);
          break;
        }
      },
      { root: null, rootMargin, threshold: 0 }
    );
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = undefined;
  }
}

if (!customElements.get('collection-custom-kit-lazy')) {
  customElements.define('collection-custom-kit-lazy', CollectionCustomKitLazy);
}
